import React from 'react';
import { downloadAdminReceiptsExport } from '../../diagnostics/export.js';

export function ReceiptsExportCard(props: {
  baseUrl: string;
  siteKey: string;
  from: string; // yyyy-mm-dd
  to: string; // yyyy-mm-dd
  bearer?: string;
}) {
  const { baseUrl, siteKey, from, to, bearer } = props;
  return (
    <div className="rounded-lg border p-4 text-sm">
      <h2 className="text-lg font-semibold mb-2">Receipts Export</h2>
      <div className="flex flex-wrap gap-2 items-end">
        <button
          className="px-3 py-1 rounded border"
          onClick={() =>
            downloadAdminReceiptsExport({
              baseUrl,
              siteKey,
              fromIso: `${from}T00:00:00Z`,
              toIso: `${to}T23:59:59Z`,
              format: 'jsonl',
              authToken: bearer,
            }).catch((e) => alert(String(e)))
          }
        >
          Download JSONL
        </button>
      </div>
      <p className="text-xs text-gray-500 mt-2">
        Tamper‑evident receipts (JSONL). Use the validator CLI to verify chain and signatures.
      </p>
    </div>
  );
}
